export default function isUndefined(val: String | undefined) {
  var undefinedVar = void (0);
  return val === undefinedVar;
}

